<template>
  <Modal
    class="tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px]"
    :visible="showRef"
    border-radius="4px"
    :overflow-y-scroll="false"
    @close="handleCloseModal"
  >
    <ModalHeader
      :class="`modal-header`"
      :title="
        getComponentUiText(
          'app-component-assessment-update-assessment-detail-modal-title-1',
        )
      "
      @close="handleClose"
    />
    <div
      class="tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[40px] tw-self-stretch tw-p-[40px] tw-bg-[#FFFFFF]"
    >
      <div
        class="tw-flex tw-items-start tw-flex-col tw-gap-[15px] headingWrapper"
      >
        <span
          class="tw-text-[#211F58] tw-text-[22px] tw-not-italic tw-font-semibold tw-leading-[100%]"
          >{{
            getComponentUiText(
              "app-component-assessment-update-assessment-detail-modal-details-1",
            )
          }}</span
        >
        <span
          class="tw-text-[#231F20] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]"
          >{{
            getComponentUiText(
              "app-component-assessment-update-assessment-detail-modal-description-1",
            )
          }}</span
        >
      </div>
      <div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-[25px]">
        <div
          class="tw-flex tw-flex-col tw-justify-between md:tw-items-start tw-gap-[20px] tw-self-stretch tw-rounded-[4px] tw-p-[10px] md:tw-p-[25px] main"
        >
          <div
            class="tw-w-full tw-flex md:tw-items-center tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row"
          >
            <div
              class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px]"
            >
              {{
                getComponentUiText(
                  "app-component-assessment-update-assessment-detail-modal-assessment-name-1",
                )
              }}
            </div>
            <div
              class="tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative"
            >
              <BFormInput
                v-model="name"
                data-cy="update-assessment-detail-assessment-name"
                type="text"
                :placeholder="
                  getComponentUiText(
                    'app-component-assessment-create-assessment-modal-field-placeholder-name-1',
                  )
                "
                :class="`tw-border tw-text-[#231F20] tw-text-[15px] tw-h-[66px] tw-leading-none tw-px-[20px] tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF]`"
                class="autoFocus"
              />
            </div>
          </div>
          <div
            class="tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row"
          >
            <div
              class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px] tw-pt-[21px]"
            >
              {{
                getComponentUiText(
                  "app-component-assessment-update-assessment-detail-modal-assessment-description-1",
                )
              }}
            </div>
            <div
              class="tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative"
            >
              <textarea
                ref="autoTextarea"
                v-model="description"
                data-cy="update-assessment-detail-assessment-description"
                :placeholder="
                  getComponentUiText(
                    'app-component-assessment-create-assessment-modal-field-placeholder-description-1',
                  )
                "
                :style="`outline-color : #EFF0F1; overflow: auto; resize: none`"
                class="auto-expand tw-max-h-[130px] tw-min-h-[130px] tw-text-[15px] tw-font-normal tw-leading-none tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1]"
                @input="autoResize"
              ></textarea>
            </div>
          </div>
          <div
            class="tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row"
          >
            <div
              class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px] tw-pt-[21px]"
            >
              {{
                getComponentUiText(
                  "app-component-assessment-update-assessment-detail-modal-reporting-date-1",
                )
              }}
            </div>
            <div
              class="tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative tw-z-10"
            >
              <DatePickInput
                v-model="reportingDate"
                :placeholder="
                  getComponentUiText(
                    'app-component-assessment-modal-complete-assesment-placeholder-report-date-1',
                  )
                "
                :disabled="false"
                :class-name="`tw-w-full !tw-bg-[#FFF] !tw-border tw-text-[#231F20] !tw-text-[15px]`"
                data-cy-id="modal-complete-assessment-reporting-date"
                :focus="true"
                :custom-input-class="`tw-flex tw-flex-1`"
                @update:model-value="
                  (value) => (value ? (reportingDate = value) : '')
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div class="tw-flex tw-flex-row tw-justify-end tw-items-center tw-w-full">
        <b-button
          style="line-height: 100%; border: 2px solid; height: 39px"
          variant="primary"
          class="tw-w-fit tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
          type="submit"
          @click="handleClose"
        >
          {{
            getComponentUiText(
              "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
            )
          }}
        </b-button>
        <ButtonLoading
          :title="
            getComponentUiText(
              'app-assessment-modal-bulk-answer-question-button-text-1',
            )
          "
          :is-loading="isLoading"
          @click-action="updateAssessment"
        />
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch, computed, onMounted, PropType } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";
import { showSuccessToast } from "@/services/apiRoutes";
import ButtonLoading from "../common/buttonLoading.vue";
import DatePickInput from "../common/datePickInput.vue";

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  checklistAssessmentData: {
    type: Object as PropType<IAssessmentDetail>,
    required: true,
  },
});

let showRef = ref(props.show);
const name = ref(props.checklistAssessmentData.checklistName);
const isLoading = ref(false);
const description: any = ref(
  props.checklistAssessmentData.checklistDescription,
);
const reportingDate = ref(props.checklistAssessmentData.checklistDateReporting);
const autoTextarea: any = ref(null);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const autoResize = () => {
  if (autoTextarea.value) {
    autoTextarea.value.style.height = "auto"; // Reset height
    autoTextarea.value.style.height = autoTextarea.value.scrollHeight + "px"; // Set height based on content
  }
};

onMounted(() => {
  autoResize();
});

const emit = defineEmits(["update:show", "resetModalHistory"]);

const handleClose = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleCloseModal = () => {
  if (
    name.value !== props.checklistAssessmentData.checklistName ||
    description.value !== props.checklistAssessmentData.checklistDescription ||
    reportingDate.value !== props.checklistAssessmentData.checklistDateReporting
  )
    return;
  showRef.value = false;
  emit("update:show", showRef.value);
};

const updateAssessment = async () => {
  isLoading.value = true;
  const res = await store.dispatch("Assessment/updateChecklistRename", {
    checklistId: props.checklistAssessmentData.checklistId,
    params: {
      checklistName: name.value,
      checklistDescription: description.value,
      checklistReportingDate: reportingDate.value,
    },
  });
  if (res) {
    showSuccessToast(
      getComponentUiText(
        "app-assess-assessment-modal-update-description-success-1",
      ),
    );
    handleClose();
  }
  isLoading.value = false;
};
</script>

<style lang="scss" scoped>
.main {
  border: 1px solid #eff0f1;
  background: rgba(239, 240, 241, 0.5);
  transition: all 0.3s ease-in-out;
}

textarea::placeholder {
  color: #b7b7b7;
  font-size: 15px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

input::placeholder {
  color: #b7b7b7;
  font-size: 15px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.auto-expand {
  width: 100%;
  overflow-y: hidden;
  resize: none;
  outline-color: #eff0f1;
  line-height: 18px;
  color: #231f20;
}
</style>
